import googleMap from './google-map';

export default new function findDistributor($) {
  this.init = () => {
    this.addEvents();
    this.modifyDOM();
  };

  this.modifyDOM = () => {
  };

  this.addEvents = () => {
    $('body').on('submit', '.contact-revent__form', this.eventHandlers.onSubmit);
  };

  this.eventHandlers = {
    onSubmit() {
      const $form = $(this);
      const $submitButton = $form.find('[type="submit"]');
      const data = $form.serialize();
      const url = $form.attr('action') + '&' + data;

      $submitButton.addClass('active');
      $.post(url).success(() => {
        $form.html($form.data('thanks'));
      }).always(() => {
        $submitButton.removeClass('active');
      });
      return false;
    }
  };

  this.helpers = {
  };

  return this.init;
}(jQuery);
